import numeral from 'numeral';
export function formatCurrency(amount) {
    return numeral(amount).format('$0,0.00');
}
export function formatDollars(amount) {
    if (amount === undefined) {
        return '';
    }
    if (typeof amount === 'string') {
        return "$" + amount;
    }
    return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        useGrouping: false,
    }).format(amount);
}
//# sourceMappingURL=formatting.js.map